(function (Translator) {
    // sq
    Translator.add("rate_list.rate.bg_kbcbank", "Shuma e bank\u00ebs KBC", "EvpThemeBundle", "sq");
    Translator.add("recaptcha.description", "Ky mesazh synon t\u00eb verifikoj\u00eb, n\u00ebse nj\u00eb person po shfleton dhe p\u00ebr t\u00eb shmangur sistemet automatike t\u00eb kontrollit", "EvpThemeBundle", "sq");
    Translator.add("recaptcha.title", "Jeni nj\u00eb robot?", "EvpThemeBundle", "sq");
})(Translator);
